import { Directive, DirectiveBinding } from 'vue'
import { usePermissionStoreWithOut } from '@/store-pinia/modules/permission'

const checkAuth = (el: HTMLElement, binding: DirectiveBinding) => {
  const permissionStore = usePermissionStoreWithOut()
  const { value } = binding
  if (!value) {
    return
  }
  const permissionCodes = permissionStore.getPermissionCodeList

  if (permissionCodes.includes(value)) {
    el.parentNode?.removeChild(el)
  }
}

const auth: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkAuth(el, binding)
  },
}

export default {
  name: 'auth',
  definition: auth,
}
